export default {
    path: '/institutionAdd',
    name: "InstitutionAdd",
    component: () => import(/* webpackChunkName: "abuout" */ '../../views/institution/institutionAdd.vue')
}